import { render, staticRenderFns } from "./Fra.vue?vue&type=template&id=242e627e&scoped=true"
import script from "./Fra.vue?vue&type=script&lang=js"
export * from "./Fra.vue?vue&type=script&lang=js"
import style0 from "./Fra.vue?vue&type=style&index=0&id=242e627e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e627e",
  null
  
)

export default component.exports